import React, { Fragment, useState } from 'react'

import {
  filter,
  getIsPriceFilter,
  MAX_OPTIONS_TO_FILTER,
  ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_FILTER,
  ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_PRICE_FILTER,
} from '../../domains/filters'
import Filter from '../filter/filter'
import FilterMobile from '../filterMobile/filterMobile'
import { Button } from '../button/button'
import Modal from '../modal/modal'
import styles from './filters.module.css'

const Filters = (props) => {
  const { filters, onChange } = props

  const [filterMobileColorModal, setFilterMobileColorModal] = useState(false)
  const [filterMobilePriceModal, setFilterMobilePriceModal] = useState(false)
  const [
    filterMobileColorOptionsSelected,
    setFilterMobileColorOptionsSelected,
  ] = useState(false)
  const [
    filterMobileColorHasMaximunNumberOfOptionsSelected,
    setFilterMobileColorHasMaximunNumberOfOptionsSelected,
  ] = useState(false)
  const [
    filterMobilePriceHasMaximunNumberOfOptionsSelected,
    setFilterMobilePriceHasMaximunNumberOfOptionsSelected,
  ] = useState(false)
  const [
    filterMobilePriceOptionsSelected,
    setFilterMobilePriceOptionsSelected,
  ] = useState(false)

  const handleOptionsSelectedChange = (type, options) => {
    const isPriceFilter = getIsPriceFilter(type)

    if (isPriceFilter) {
      if (options?.length >= MAX_OPTIONS_TO_FILTER) {
        setFilterMobilePriceHasMaximunNumberOfOptionsSelected(true)
        return
      } else {
        setFilterMobilePriceHasMaximunNumberOfOptionsSelected(false)
        return
      }
    }

    if (!isPriceFilter) {
      if (options?.length >= MAX_OPTIONS_TO_FILTER + 1) {
        setFilterMobileColorHasMaximunNumberOfOptionsSelected(true)
        return
      } else {
        setFilterMobileColorHasMaximunNumberOfOptionsSelected(false)
        return
      }
    }
  }

  const handleApplyFilterMobile = (type, options) => {
    if (onChange) onChange(type, options)
    if (type === filter.type.color) setFilterMobileColorModal(false)
    if (type === filter.type.precio) setFilterMobilePriceModal(false)
    if (type === filter.type.color) setFilterMobileColorOptionsSelected(options)
    if (type === filter.type.precio)
      setFilterMobilePriceOptionsSelected(options)
  }

  const handleOpenFilterMobileColorModal = () => {
    setFilterMobileColorModal(!filterMobileColorModal)
  }

  const handleCloseFilterMobileColorModal = () => {
    setFilterMobileColorModal(false)
  }

  const handleOpenFilterMobilePriceModal = () => {
    setFilterMobilePriceModal(!filterMobilePriceModal)
  }

  const handleCloseFilterMobilePriceModal = () => {
    setFilterMobilePriceModal(false)
  }

  return (
    <Fragment>
      <aside className={styles.filters}>
        <Filter filter={filters.color} onChange={onChange} />
        <Filter filter={filters.bodega} onChange={onChange} />
        <Filter filter={filters.uva} onChange={onChange} />
        <Filter filter={filters.precio} onChange={onChange} />
      </aside>
      <aside className={styles.filtersMobile}>
        <article className={styles.filterMobile}>
          <Button
            type="outline"
            size="small"
            label={filter.placeholder.mobile.color}
            onClick={handleOpenFilterMobileColorModal}
          />
          <Modal
            open={filterMobileColorModal}
            onClose={handleCloseFilterMobileColorModal}
            closeButton={false}
          >
            <FilterMobile
              title="Filtra vinos por tipo"
              filter={filters.color}
              selected={filterMobileColorOptionsSelected}
              disabled={filterMobileColorHasMaximunNumberOfOptionsSelected}
              disabledMessage={ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_FILTER}
              onChange={handleOptionsSelectedChange}
              onCancel={handleCloseFilterMobileColorModal}
              onApply={handleApplyFilterMobile}
            />
          </Modal>
        </article>
        <article className={styles.filterMobile}>
          <Button
            type="outline"
            size="small"
            label={filter.placeholder.mobile.precio}
            onClick={handleOpenFilterMobilePriceModal}
          />
          <Modal
            open={filterMobilePriceModal}
            onClose={handleCloseFilterMobilePriceModal}
            closeButton={false}
          >
            <FilterMobile
              title="Filtra vinos por precio"
              filter={filters.precio}
              selected={filterMobilePriceOptionsSelected}
              disabled={filterMobilePriceHasMaximunNumberOfOptionsSelected}
              disabledMessage={
                ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_PRICE_FILTER
              }
              onChange={handleOptionsSelectedChange}
              onCancel={handleCloseFilterMobilePriceModal}
              onApply={handleApplyFilterMobile}
            />
          </Modal>
        </article>
      </aside>
    </Fragment>
  )
}

export default Filters
